import React, {useState, memo} from 'react';
import { useTranslation } from "react-i18next";
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { ConductivitySensorRanges } from './SensorRanges';
import { ConductivitySensorParameters } from './SensorParameters';
import { ConductivityAdvanced} from './Advanced'



const Conductivity = memo(props => {
  const { t } = useTranslation('common')
  const [key, setKey] = useState(props.tabIndex)

  const processTabSelect = (k) => {
    setKey(k)
    props.setTabIndex(k)
  }

    return (   <Tabs defaultActiveKey="0" activeKey={key} id="general" onSelect={(k) => processTabSelect(k)}>
              <Tab eventKey="0" title={t('conductivity.tabs.sensor_ranges')}>
                <ConductivitySensorRanges showKeyboard={props.showKeyboard}/>
              </Tab>
              <Tab eventKey="1" title={t('conductivity.tabs.sensor_parameters')}>
                <ConductivitySensorParameters showKeyboard={props.showKeyboard} />
              </Tab>
              <Tab eventKey="2" title={t('conductivity.tabs.advanced')}>
                <ConductivityAdvanced showKeyboard={props.showKeyboard}/>
              </Tab>
            </Tabs>
        
    )
})

  
export default Conductivity
